import { trpc } from '@/shared/api';

export const useProductReviewSummaryQuery = (productId: string) =>
  trpc.reviews.summaryByProduct.useQuery({ productId });
